import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translateResourceString } from '../../util/translationUtility';

import { CheckoutCouponContainer } from './Coupon'
import { CheckoutCommentsContainer } from './Comments'
import { CartListContainer } from './Cart'
import { CheckoutShippingAddress } from './Address'
import { CheckoutSummaryContainer } from './Summary'
import { CheckoutCompleteContainer } from './PlaceOrder'
import { MessagesList } from './UserMessaging'
import { CheckoutShipment } from './ShippingMethod'
import { CheckoutPayment } from './PaymentMethod'
import { CheckoutBillingAddress } from './Address'
import CheckoutPromoGiftCard from './CheckoutPromoGiftCard'

class Components extends Component {

    componentDidMount() {

        // BBS DDD This should be refactored and moved into component animations, or
        // a renderProp component
        // https://reactjs.org/docs/render-props.html

        let docWidth = 0, docTop = 0;
        if (typeof document !== 'undefined' && document.documentElement) {

            docWidth = document.documentElement.clientWidth;
            docTop = document.documentElement.getBoundingClientRect().top
        } else {
            if (typeof window.innerWidth !== 'undefined' && window.innerWidth)
                docWidth = window.innerWidth;
        }
        const minPortWidthPx = 767;
        if (docWidth > minPortWidthPx) {
            const affixedElt = document.getElementById('right-summary');
            const conteainerElt = document.getElementById('right-summary-container');
            affixedElt.setAttribute("data-spy", "affix");
            const containerClientRect = conteainerElt ? conteainerElt.getBoundingClientRect() : { top: 0, height: 0 };
            affixedElt.setAttribute("data-offset-top", containerClientRect.top - docTop);
            affixedElt.setAttribute("data-offset-bottom", containerClientRect.top + containerClientRect.height - affixedElt.getBoundingClientRect().height);
            let affixedWidth = affixedElt.getBoundingClientRect().width;
            affixedElt.style.width = affixedWidth;

            const rightSummaryDescendent = (target) => {
                const rightSummary = document.getElementById('#right-summary');
                if(rightSummary) {
                return rightSummary.matches(target) || rightSummary.contains(target);
                }
                return false;
            }

            document.addEventListener('affix.bs.affix', (e) => {
                if(rightSummaryDescendent(e.target)) {
                e.target.setAttribute('style', `top: 0px; width: ${affixedWidth}px` );
                }
            });

            document.addEventListener('affixed-top.bs.affix', (e) => {
                if(rightSummaryDescendent(e.target)) {
                e.target.setAttribute('style', ` width: ${affixedWidth}px`);
                }
            });
            
            if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
                window.addEventListener('resize', (e) => {
                    // BBS DDD 2018-02-19 This code attempts to resize the width of the affixed
                    // element when the window resizes, but nothing happens
                    const hasAffix = affixedElt.classList.contains('affix');
                    if (hasAffix) {
                        affixedElt.classList.remove('affix');
                        affixedElt.classList.add('affix-top');
                    }
                    affixedWidth = affixedElt.getBoundingClientRect().width;
                    if (hasAffix) {
                        affixedElt.classList.remove('affix-top');
                        affixedElt.classList.add('affix');
                    }
                })
            }
        }
    }

    render() {
        if (this.props.checkoutIsEmpty) {
            return (
                <div className="checkout">
                    <div className="col-12 text-center">
                        <p>{translateResourceString("/Checkout/EmptyCartMessage")}</p>
                        <p><a href="/">{translateResourceString("/Checkout/BackToHomeLink")}</a></p>
                    </div>
                </div>
            )
        }
        return (
            <React.Fragment>
                {this.props.showInventoryWarning &&
                    <div className="row">
                        <div className="col-12">
                            <div className="inventory-message alert alert-warning">
                                {translateResourceString("/Checkout/NotEnoughtInventoryMessage")}
                            </div>
                        </div>
                    </div>
                }
                <div className="checkout row">
                    <div className="col-12 d-block d-md-none">
                        <CheckoutSummaryContainer />
                        <div className="mb-2">
                            <CheckoutCompleteContainer />
                            <MessagesList />
                        </div>
                    </div>

                    <div className="col-md-8 mb-3">
                        <CheckoutShippingAddress />
                        <CheckoutShipment />
                        <CheckoutCouponContainer />
                        <CheckoutPayment />
                        <CheckoutBillingAddress />
                        <CheckoutCommentsContainer />
                        <CheckoutPromoGiftCard />
                        <CartListContainer />
                        <CheckoutCompleteContainer />
                    </div>

                    <div className="col-md-4 d-none d-md-block" id='right-summary-container'>
                        <div id='right-summary'>
                            <CheckoutSummaryContainer />
                            <CheckoutCompleteContainer />
                            <MessagesList />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    checkoutIsEmpty: state.entities.CartItems.length < 1,
    showInventoryWarning: state.entities.CartItems.find(a => !a.IsInStock)
});

export default connect(mapStateToProps)(Components)
